import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SilentAuthGuard implements CanActivate {
  constructor(private authservice: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authservice.user) {
      this.authservice
        .loginSilent()
        .then(() => {
          return true;
        })
        .catch(() => {
          // ignore error
        });
    }

    return true;
  }
}
